import slugify from 'slugify'

export const getSlugFromString = (string = '') => {
    const result = slugify(string, {
        replacement: '_',
        remove: undefined,
        lower: true,
    }).replace('_-_', '_').replace('-', '_')
    
    //console.log(string, " => ", result)
    return result
}
class CollectionDB {
    constructor(name) {
        this.name = name
        this.data = []
    }

    compare = (a, b, key) => {
        // Use toUpperCase() to ignore character casing
        const genreA =
            typeof a[key] === 'string' ? a[key].toUpperCase() : a[key]
        const genreB =
            typeof b[key] === 'string' ? b[key].toUpperCase() : b[key]

        let comparison = 0
        if (genreA > genreB) {
            comparison = 1
        } else if (genreA < genreB) {
            comparison = -1
        }
        return comparison
    }

    clear = () => (this.data = [])

    upsert = doc => {
        let isExisting = false
        let index = null
        this.data.map((item, i) => {
            if (item.id == doc.id) {
                isExisting = true
                index = i
            }
        })
        if (isExisting) {
            this.data[index] = { ...this.data[index], ...doc }
            return index
        } else {
            this.data.push(doc)
            return this.data.length
        }
    }

    insert = doc => {
        this.data.push(doc)
        return this.data.length
    }

    find = (args = {}, params) => {
        const argsKeys = Object.keys(args)

        const results = this.data.filter(item => {
            let test = true
            argsKeys.map(key => {
                if (typeof args[key] === 'object') {
                    const subkeys = Object.keys(args[key])
                    if (subkeys[0] === '$in') {
                        test = args[key]['$in'].indexOf(item[key]) > -1
                    } else {
                        subkeys.map(subkey => {
                            if (
                                !item[key] ||
                                item[key][subkey] !== args[key][subkey]
                            ) {
                                test = false
                            }
                        })
                    }
                } else if (item[key] !== args[key]) {
                    test = false
                }
            })
            return test
        })

        if (params) {
            results.sort((a, b) => this.compare(a, b, params.sort))
        }

        return results
    }

    findOne = args => {
        const argsKeys = Object.keys(args)
        return this.data.find(item => {
            let test = true
            argsKeys.map(key => {
                if (item[key] !== args[key]) {
                    test = false
                }
            })
            return test
        })
    }
}

export const MongoSites = new CollectionDB('sites')
export const MongoTypeGuests = new CollectionDB('type_guests')
export const MongoPointsOfSale = new CollectionDB('points_of_sale')
export const MongoMenus = new CollectionDB('menus')
export const MongoTypeMeals = new CollectionDB('type_meals')
export const MongoTypeRecipes = new CollectionDB('type_recipes')
export const MongoRecipes = new CollectionDB('recipes')
export const MongoIntolerances = new CollectionDB('intolerances')

const SAVE_DB_KEY = 'newrest-db'

export const saveDbToLocalStorage = () => {
    const db = {
        sites: MongoSites.find(),
        typesGuest: MongoTypeGuests.find(),
        pointsOfSales: MongoPointsOfSale.find(),
        menus: MongoMenus.find(),
        typesMeals: MongoTypeMeals.find(),
        typesRecipes: MongoTypeRecipes.find(),
        intolerances: MongoIntolerances.find(),
        recipes: MongoRecipes.find(),
    }
    localStorage.setItem(SAVE_DB_KEY, JSON.stringify({ ...db }))
}

export const getDbFromLocalStorage = () => {
    const savedDb = JSON.parse(localStorage.getItem(SAVE_DB_KEY)) || {}
    const {
        sites = [],
        typesGuest = [],
        pointsOfSales = [],
        menus = [],
        typesMeals = [],
        typesRecipes = [],
        intolerances = [],
        recipes = [],
    } = savedDb

    sites.map(item =>
        MongoSites.upsert({ ...item, slug: getSlugFromString(item.name) })
    )
    typesGuest.map(item =>
        MongoTypeGuests.upsert({ ...item, slug: getSlugFromString(item.name) })
    )
    pointsOfSales.map(item =>
        MongoPointsOfSale.upsert({
            ...item,
            slug: getSlugFromString(item.name),
        })
    )
    typesMeals.map(item =>
        MongoTypeMeals.upsert({ ...item, slug: getSlugFromString(item.name) })
    )
    typesRecipes.map(item =>
        MongoTypeRecipes.upsert({ ...item, slug: getSlugFromString(item.name) })
    )
    intolerances.map(item =>
        MongoIntolerances.upsert({
            ...item,
            slug: getSlugFromString(item.name),
        })
    )
    menus.map(item =>
        MongoMenus.upsert({ ...item, slug: getSlugFromString(item.name) })
    )
    recipes.map(item => MongoRecipes.upsert(item))
    //localStorage.removeItem(SAVE_DB_KEY)
}

export const resetDatabase = () => {
    MongoSites.clear()
    MongoTypeGuests.clear()
    MongoPointsOfSale.clear()
    MongoMenus.clear()
    MongoTypeMeals.clear()
    MongoTypeRecipes.clear()
    MongoRecipes.clear()
    MongoIntolerances.clear()

    return true
}

export const resetSiteDatabase = () => {
    MongoPointsOfSale.clear()
    MongoMenus.clear()
    MongoRecipes.clear()

    return true
}

export const setCountryDatabase = async ({ data = {} }) => {
    await resetDatabase()
    const {
        Sites = [],
        Intolerances = [],
        TypeGuests = [],
        TypeMeals = [],
        TypeRecipes = [],
    } = data
    Sites.map(item =>
        MongoSites.upsert({ ...item, slug: getSlugFromString(item.name) })
    )
    Intolerances.map(item =>
        MongoIntolerances.upsert({
            ...item,
            slug: getSlugFromString(item.name),
        })
    )
    TypeGuests.map(item =>
        MongoTypeGuests.upsert({ ...item, slug: getSlugFromString(item.name) })
    )
    TypeMeals.map(item =>
        MongoTypeMeals.upsert({ ...item, slug: getSlugFromString(item.name) })
    )
    TypeRecipes.map(item =>
        MongoTypeRecipes.upsert({ ...item, slug: getSlugFromString(item.name) })
    )

    return true
}

export const setSiteDatabase = async ({ data = [], date }) => {
    data.map(singlePointOfSale => {
        // destructure pointofsale to extract menus
        const { menus = [], ...pointOfSale } = singlePointOfSale
        MongoPointsOfSale.upsert({
            ...pointOfSale,
            slug: getSlugFromString(pointOfSale.name),
        })

        return menus.map(singleMenu => {
            // destructure menu to extract recipes
            const { recipes = [], ...menu } = singleMenu

            // find if menu exists
            const existingMenu = MongoMenus.findOne({ id: menu.id })
            if (existingMenu) {
                existingMenu.pointOfSaleSlugs[
                    getSlugFromString(pointOfSale.name)
                ] = true
                MongoMenus.upsert(existingMenu)
            } else {
                // insert menu with a link to the pointofsale
                MongoMenus.upsert({
                    ...menu,
                    slug: getSlugFromString(menu.name),
                    mealTypeSlug: getSlugFromString(
                        MongoTypeMeals.findOne({
                            id: menu.mealTypeId,
                        }).name,
                        '_'
                    ),
                    guestTypeSlug: getSlugFromString(
                        MongoTypeGuests.findOne({
                            id: menu.guestTypeId,
                        }).name,
                        '_'
                    ),
                    pointOfSaleSlugs: {
                        [getSlugFromString(pointOfSale.name)]: true,
                    },
                })
            }

            // find meal type and add pointOfSaleId
            const existingMealType = MongoTypeMeals.findOne({
                id: menu.mealTypeId,
            })
            if (existingMealType) {
                if (!existingMealType.pointOfSaleSlugs) {
                    existingMealType.pointOfSaleSlugs = {}
                }
                existingMealType.pointOfSaleSlugs[
                    getSlugFromString(pointOfSale.name)
                ] = true
                MongoTypeMeals.upsert(existingMealType)
            }

            // find guestTypeId and add pointOfSaleId
            const existingGuestType = MongoTypeGuests.findOne({
                id: menu.guestTypeId,
            })
            if (existingGuestType) {
                if (!existingGuestType.pointOfSaleSlugs) {
                    existingGuestType.pointOfSaleSlugs = {}
                }
                existingGuestType.pointOfSaleSlugs[
                    getSlugFromString(pointOfSale.name)
                ] = true
                MongoTypeGuests.upsert(existingGuestType)
            }

            return recipes.map((recipe, index) => {
                // find if recipe exists
                const existingRecipe = MongoRecipes.findOne({
                    id: recipe.id,
                })
                if (existingRecipe) {
                    if (!existingRecipe.menuSlugs) {
                        existingRecipe.menuSlugs = {}
                    }
                    if (!existingRecipe.dates) {
                        existingRecipe.dates = {}
                    }
                    // add link to the pointofsale on this menu
                    existingRecipe.menuSlugs[
                        getSlugFromString(menu.name)
                    ] = true
                    existingRecipe.dates[date] = true
                    MongoRecipes.upsert(existingRecipe)
                } else {
                    // insert menu with a link to the pointofsale
                    MongoRecipes.upsert({
                        ...recipe,
                        order: index,
                        menuSlugs: { [getSlugFromString(menu.name)]: true },
                        dates: { [date]: true },
                    })
                }

                const existingRecipeType = MongoTypeRecipes.findOne({
                    id: recipe.recipeTypeId,
                })

                if (existingRecipeType) {
                    if (!existingRecipeType.menuSlugs) {
                        existingRecipeType.menuSlugs = {}
                    }
                    existingRecipeType.menuSlugs[
                        getSlugFromString(menu.name)
                    ] = true
                    MongoTypeRecipes.upsert(existingRecipeType)
                }
            })
        })
    })

    return true
}
